import {
  Box,
  Button
} from '@mui/material';
import { SiteUser_RegisterInput } from 'generated/graphql';
import { authUtil } from 'modules/common';
import { RegisterAccountForm } from 'modules/components/layer12';
import { RegisterConfirmationModal } from 'modules/components/layer15';
import {
  useCallback,
  useState
} from 'react';
import {
  useNavigate,
  useParams
} from 'react-router-dom';
import * as ds from './dataService';



export type RegisterAccountSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: RegisterAccountSectionProps) => {
  const navigate = useNavigate();
  const [fnRegisterUser] = ds.useRegisterUser();

  const [
    err,
    setErr
  ] = useState('');
  const params = useParams();
  const {
    formState,
    genFieldProps,
    dispatch
  } = ds.useQuery({
    inviteCode: params.inviteCode ?? ''
  });



  const registerUserFromState = async () => {
    const input: SiteUser_RegisterInput = {
      preferredEmail: formState.email,
      firstName: formState.firstName,
      lastName: formState.lastName,
      phoneNumber: '',

      inviteCode: formState.inviteCode
    };

    await fnRegisterUser(input);
  };



  const handleClickRegister = useCallback(async () => {
    try {
      const signUpStep = await authUtil.signUp(formState.email, formState.password);
      // localStorage.setItem(STORAGE_KEY, (numAttempts + 1).toString());
      if (signUpStep === 'CONFIRM_SIGN_UP') {
        dispatch({
          type: 'UPDATE',
          payload: {
            property: 'confirmationModalVisible',
            value: true
          }
        });
      }
    } catch (err) {
      if (err instanceof Error) {
        setErr(err.message);
      }
    }
  }, [
    dispatch,
    formState.email,
    formState.password
  ]);



  const handleConfirmCode = async (code: string) => {
    try {
      await authUtil.confirmSignUp({
        email: formState.email,
        password: formState.password,
        confirmationCode: code
      });

      await authUtil.signIn(formState.email, formState.password);
      await registerUserFromState();

      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'confirmationModalVisible',
          value: false
        }
      });

    } catch (err) {
      if (err instanceof Error) {
        setErr(err.message);
      }
    }
  };

  const fields: (keyof ds.IFormState)[] = [
    'email',
    'firstName',
    'lastName',
    'password',
    'confirmPassword'
  ];

  return (
    <Box
      marginTop='8rem'
      maxWidth='50rem'
    >
      {
        formState.confirmationModalVisible && (
          <RegisterConfirmationModal.FC
            form={{
              formState,
              genFieldProps,
              dispatch
            }}
            isVisible={formState.confirmationModalVisible}
            handleClose={() => {
              dispatch({
                type: 'UPDATE',
                payload: {
                  property: 'confirmationModalVisible',
                  value: !formState.confirmationModalVisible
                }
              });
            }}
            handleConfirmCode={handleConfirmCode}
            key='register'
          />
        )
      }

      <RegisterAccountForm.FC
        formState={formState}
        genFieldProps={genFieldProps}
        dispatch={dispatch}
        fields={fields}
        handleRegisterUser={handleClickRegister}
        errMessage={err}
      />

      <Button
        variant='text'
        sx={{
          mt: 1,
          color: (theme) => theme.palette.gray.dark
        }}
        onClick={() => navigate('/auth/login', {
          replace: true
        })}
      >
        Already have an account?
        <Box
          component='span'
          sx={{
            ml: 1,
            color: (theme) => theme.palette.primary.main
          }}
        >
          Log in here.
        </Box>
      </Button>
    </Box>
  );
};
